import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faq";
import { testimonials } from "@/mocks/community";

export default function TrustSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-chat-heart-line" />
              Circle Voices
            </p>
            <h2 className="mt-2 font-display text-2xl font-black text-foreground-950 md:text-4xl">
              吃瓜群众的进圈口碑
            </h2>
          </div>
          <Link to="/about" className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800 cursor-pointer">
            了解我们
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* testimonials */}
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-2xl border border-background-200 bg-background-100/60 p-5">
              <div className="flex items-center gap-1 text-primary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 font-display text-base font-bold text-accent-700">
                  {t.name.slice(1, 2)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role} · {t.tag}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* faq teaser + CTA */}
        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <h3 className="font-display text-xl font-black text-foreground-950 md:text-2xl">
              新手常问的 <span className="text-accent-700">几个问题</span>
            </h3>
            <div className="mt-5 space-y-3">
              {faqs.slice(0, 4).map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left cursor-pointer"
                    >
                      <span className="flex items-center gap-3 text-sm font-semibold text-foreground-900">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 font-display text-xs font-bold text-primary-700">
                          Q
                        </span>
                        {f.q}
                      </span>
                      <i className={`ri-arrow-down-s-line shrink-0 text-lg transition-transform ${open ? "rotate-180 text-primary-600" : "text-foreground-400"}`} />
                    </button>
                    <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="border-t border-background-200 px-4 py-3.5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <Link
              to="/faq"
              className="mt-4 inline-flex whitespace-nowrap items-center gap-1.5 rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-700 cursor-pointer"
            >
              去常见问题页看全部
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <aside className="lg:col-span-5">
            <div className="flex h-full flex-col justify-between rounded-2xl bg-gradient-to-br from-accent-600 to-accent-700 p-6 text-background-50 md:p-7">
              <div>
                <i className="ri-chat-new-line text-3xl" />
                <h3 className="mt-4 font-display text-xl font-bold leading-snug md:text-2xl">
                  有个大瓜你觉得该被更多人看见？
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-accent-50">
                  把你整理的时间线、线索或看法投给我们。信息确认可靠后，会进入瓜单或复盘专栏并标注你的来源。
                </p>
              </div>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/about#contact"
                  className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-accent-900 hover:bg-background-100 cursor-pointer"
                >
                  <i className="ri-send-plane-line" />
                  我要投稿
                </Link>
                <Link
                  to="/gua/e1"
                  className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md border border-accent-300 px-5 py-2.5 text-sm font-semibold text-accent-50 hover:bg-accent-700 cursor-pointer"
                >
                  先看看最新瓜单
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}